var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.5V6.6c0-.5.6-.8 1-.5l7.5 6.3c.9.7 2.2.7 3.1 0L19 6.2c.4-.3 1 0 1 .5v7.9c0 1.4-1.1 2.5-2.5 2.5h-15C1.1 17 0 15.9 0 14.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.3 9.7-8-6.6C.8 2.8 1 2 1.6 2h16.8c.6 0 .8.8.4 1.2l-8 6.6c-.5.3-1.1.3-1.5-.1z"
  })));
};
export default SvgMail;